// src/Pages/Admin/resources/AdminSupportMessages.js
import React from "react";
import {
  Resource,
  List,
  Datagrid,
  TextField,
  BooleanField,
  DateField,
  FunctionField,
  TextInput,
  Pagination,
  Filter,
  Show,
  SimpleShowLayout,
  BooleanInput,
  Button,
  useNotify,
  useRefresh,
  ShowButton,
} from "react-admin";
import { createDataProvider } from "../core/dataProvider";

import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

const apiUrl = `${process.env.REACT_APP_API_URL}/admin_support_messages`;
const resolveUrl = `${process.env.REACT_APP_API_URL}/admin_support_messages/resolve`;

/* ---------------- Filters ---------------- */
const SupportFilter = (props) => (
  <Filter {...props}>
    <TextInput source="q" label="Search" alwaysOn />
    <TextInput source="email" label="Email" />
    <TextInput source="username" label="Username" />
    <BooleanInput source="is_resolved" label="Resolved" />
  </Filter>
);

/* ---------------- Resolve Button ---------------- */
const ResolveButton = ({ record }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  if (!record) return null;

  const toggleResolve = async () => {
    try {
      const token = localStorage.getItem("jwtToken");
      const res = await fetch(resolveUrl, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          message_id: record.message_id,
          is_resolved: !record.is_resolved,
        }),
      });

      const data = await res.json();

      if (res.ok && !data.error) {
        notify("✅ Status updated", { type: "success" });
        refresh();
      } else {
        notify(data.msg || "Failed to update", { type: "warning" });
      }
    } catch (e) {
      notify("❌ Network error", { type: "error" });
    }
  };

  return (
    <Button
      label={record.is_resolved ? "Unresolve" : "Resolve"}
      onClick={toggleResolve}
      startIcon={record.is_resolved ? <CloseIcon /> : <CheckIcon />}
    />
  );
};

/* ---------------- List ---------------- */
export const SupportMessageList = (props) => (
  <List
    {...props}
    filters={<SupportFilter />}
    perPage={25}
    pagination={<Pagination rowsPerPageOptions={[10, 25, 50]} />}
  >
    <Datagrid rowClick="show" bulkActionButtons={false}>
      <TextField source="subject" />
      <TextField source="email" />
      <FunctionField
        label="Username"
        render={(record) => record.user?.username}
      />
      <BooleanField source="is_resolved" />
      <DateField source="created_at" showTime />
      <ResolveButton />
      <ShowButton />
    </Datagrid>
  </List>
);

/* ---------------- Show ---------------- */
export const SupportMessageShow = (props) => (
  <Show {...props}>
    <SimpleShowLayout>
      <TextField source="message_id" label="Message ID" />
      <TextField source="subject" />
      <TextField source="email" />
      <FunctionField
        label="Username"
        render={(record) => record.user?.username}
      />
      <TextField source="message" />
      <BooleanField source="is_resolved" />
      <DateField source="created_at" showTime />
    </SimpleShowLayout>
  </Show>
);

/* ---------------- Resource ---------------- */
export const SupportMessageResource = (
  <Resource
    name="support_messages"
    list={SupportMessageList}
    show={SupportMessageShow}
    options={{ label: "Support Messages" }}
  />
);
